/**
 * LenisContainer Custom Element
 * 
 * Provides a wrapper for smooth internal scrolling within a specific container.
 * Implements "Scroll Chaining" to allow nested scrolling to feel native.
 */
const initLenisContainer = () => {
  if (window.BaseComponent && !customElements.get('lenis-container')) {
    class LenisContainer extends BaseComponent {
      constructor() {
        super();
        this.lenis = null;
      }

      init() {
        this.wrapper = this;
        this.content = this.firstElementChild;

        if (!this.content) {
          console.warn('LenisContainer: No content element found.');
          return;
        }

        if (window.Lenis) {
          this.lenis = new Lenis({
            wrapper: this.wrapper,
            content: this.content,
            lerp: 0.1,
            autoResize: true,
            duration: 1.2,
            orientation: 'vertical',
            smoothWheel: true
          });

          const raf = (time) => {
            if (!this.lenis) return;
            this.lenis.raf(time);
            requestAnimationFrame(raf);
          };

          requestAnimationFrame(raf);

          this.dataset.lenisInitialized = "true";

          // --- Scroll Chaining Logic ---
          this.addEventListener('wheel', (e) => {
            if (!this.lenis) return;

            const { deltaY } = e;
            const isScrollingDown = deltaY > 0;
            const isScrollingUp = deltaY < 0;

            const canScrollDown = this.lenis.scroll < this.lenis.limit - 1;
            const canScrollUp = this.lenis.scroll > 1;

            if ((isScrollingDown && canScrollDown) || (isScrollingUp && canScrollUp)) {
              e.stopPropagation();
            }
          }, { passive: false });
        }
      }

      disconnectedCallback() {
        if (this.lenis) {
          this.lenis.destroy();
          this.lenis = null;
        }
      }
    }

    customElements.define('lenis-container', LenisContainer);
  }
};

if (window.BaseComponent) {
  initLenisContainer();
} else {
  document.addEventListener('DOMContentLoaded', initLenisContainer);
}
